// HOC shared by registration and account manager
import { withNewParentForm } from 'components/account/Parents/New'

// presentational component specific to registration
import UI from './UI'

// in reg flow, report progress to GTM and redirect to parents list
export default withNewParentForm({
  onSuccess: data =>
    window.dataLayer &&
    window.dataLayer.push({ event: 'register.createParent' }),
  redirect: '/parents'
})(UI)
